import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { LojaImportacaoStatusChip } from 'pages/cadastro/loja/components/templates/importacao/LojaImportacaoStatusChip';
import { useQueryImportacoes } from 'pages/cadastro/loja/hooks/importacao/useQueryImportacoes';
import { LojaImportacao } from 'pages/cadastro/loja/types';
import { brlDateTime } from 'util/format';

/**
 *  Retorna as linhas da grid.
 */
const getRows = (data?: LojaImportacao[]): GridRowsProp => {
    if (Array.isArray(data) && data.length) {
        return data.map((item) => ({
            id: item.idLojaConfiguracaoImportacao,
            dhInclusao: brlDateTime(item.dhInclusao),
            dsStatusProcessamento: item.dsStatusProcessamento,
            idStatusProcessamento: item.idStatusProcessamento,
            dsValidacao: item.dsValidacao,
        }));
    }

    return [];
};

const columns: GridColDef[] = [
    { field: 'dhInclusao', headerName: 'Data da importação', flex: 1, headerAlign: 'center', align: 'center' },
    {
        field: 'dsStatusProcessamento',
        headerName: 'Situação',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: ({ row }) => <LojaImportacaoStatusChip row={row} />,
    },
];

export function LojaImportacaoGrid() {
    const { data, isFetching, refetch } = useQueryImportacoes();

    return (
        <Block>
            <PanelGrid rows={getRows(data?.data)} rowsCount={data?.total || 0} columns={columns} loading={isFetching} reload={refetch} />
        </Block>
    );
}
